import { MemberContactScreen } from '@/components/MemberContactScreen';

export default function MemberContact() {
  return <MemberContactScreen />;
}
